<template>
  <generic-error>
    <template v-slot:title>Erreur dans l'URL</template>
    <h1>Oh oh ! 🙁</h1>
    <p>Aucune facture n'a été trouvée avec cet identifiant.</p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  components: {
    GenericError
  }
}
</script>

<style>
</style>
